import { getSupportedExtensions } from "@/store/features/bulkResize/utils/getSupportedExtensions";
import { useGoogleDriveUpload } from "client/hooks/upload/useGoogleDriveUpload";
import { useToggle } from "client/hooks/utils/useToggle";
import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { DropDownList } from "components/common/DropDownList/DropDownList";
import { AddIcon } from "components/common/Icons/AddIcon";
import { SmallContainer } from "components/common/SmallContainer/SmallContainer";
import { ToolTip } from "components/common/ToolTip/ToolTip";
import { DeviceUpload } from "components/common/Upload/DeviceUpload/DeviceUpload";
import { DropboxUpload } from "components/common/Upload/DropboxUpload/DropboxUpload";
import { GoogleDriveAccessErrorModal } from "components/common/Upload/GoogleDriveUpload/GoogleDriveAccessErrorModal/GoogleDriveAccessErrorModal";
import { GoogleDriveUpload } from "components/common/Upload/GoogleDriveUpload/GoogleDriveUpload";
import { UrlUpload } from "components/common/Upload/UrlUpload/UrlUpload";
import { useRouter } from "next/router";
import { useAddImages } from "./useAddImages";

export const BULK_RESIZE_DEVICE_INPUT_ID = "bulk-resizer-editor-input";

export const AddImages = () => {
    const { isOpen, open, onClose: close } = useToggle();
    const router = useRouter();
    const supportedExtensions = getSupportedExtensions(router.asPath);
    const { handleFile } = useAddImages();
    const {
        handleClick: handleGoogleDriveUploadClick,
        accessError,
        setAccessError,
        isLoading: isGoogleDriveLoading,
    } = useGoogleDriveUpload(handleFile, { allowMultiple: true, supportedExtensions }, isOpen);

    return (
        <>
            <DropDownList
                items={{
                    from_device: (
                        <DeviceUpload
                            handleFile={handleFile}
                            options={{ allowMultiple: true, supportedExtensions }}
                            htmlFileInputId={BULK_RESIZE_DEVICE_INPUT_ID + router.asPath}
                        />
                    ),
                    dropbox: (
                        <DropboxUpload
                            handleFile={handleFile}
                            options={{ allowMultiple: true, supportedExtensions }}
                            isOpen={isOpen}
                        />
                    ),
                    google_drive: (
                        <GoogleDriveUpload
                            options={{
                                allowMultiple: true,
                                onClick: handleGoogleDriveUploadClick,
                                supportedExtensions,
                            }}
                            isLoading={isGoogleDriveLoading}
                        />
                    ),
                    url_upload: <UrlUpload handleFile={handleFile} options={{ supportedExtensions }} />,
                }}
                isOpen={isOpen}
                open={open}
                close={close}
            >
                <ToolTip text={capitalize(translateFunc("common:upload"))}>
                    <SmallContainer
                        className={`cursor-pointer flex items-center justify-center ${
                            isOpen ? "bg-gray-200 dark:bg-darkSurface-200" : "bg-white dark:bg-darkSurface-300"
                        } border dark:hover:bg-darkSurface-200 border-irGray-400 dark:border-darkSurface-100 rounded-lg p-3 hover:bg-irGray-200`}
                        data-testid={`upload-list-opener`}
                    >
                        <AddIcon className="fill-black dark:fill-white" />
                    </SmallContainer>
                </ToolTip>
            </DropDownList>
            <GoogleDriveAccessErrorModal
                isOpen={accessError}
                close={() => setAccessError(false)}
                handleRetry={handleGoogleDriveUploadClick}
            />
        </>
    );
};
